
import 'babel-polyfill';

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window.$ = window.jQuery = require('jquery');


window.moment = require('moment');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};

Vue.prototype.$http = axios;

/**
 * We'll load some Vue libraries.
 */

var VueTouch = require('vue-touch');
VueTouch.config.swipe = { direction: 'horizontal' };
Vue.use( VueTouch );

/**
 * We'll load the Waypoints library which allows us to easily do what 
 * we want when the window is scrolled to an element.
 */

require('waypoints/lib/jquery.waypoints');
require('waypoints/lib/shortcuts/inview');

/**
 * We'll load the AOS library which allows us use CSS animations on scroll 
 * only applying some data- to our HTML elements.
 */

window.AOS = require('aos/dist/aos');

// AOS.init({ disable: 'mobile', });

/**
 * We'll load a simple cookies library which allows us to save and retrieve 
 * cookies in the browser.
 */

window.Cookies = require('cookies-js/dist/cookies');

Cookies.defaults = {
    path: '/',
    secure: false,
    expires: 2592000, // 30 days
};

/**
 * Google Maps library.
 */
 
window.GoogleMapsLoader = require('google-maps');


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js